/* istanbul ignore file */

import React from 'react';
import { ErrorsWrapper, useFormContext } from 'ui-builder';
import FormRows from '../FormRows';
import { FormLayoutProps } from '../index';
import useFeatureToggleService from 'feature-toggle';
import ShadcnDefaultLayout from './ShadcnDefaultLayout';

import styles from './DefaultLayout.module.scss';

function LegacyDefaultLayout({
  children,
  buttons,
  className,
  title,
  testID,
  isSubmitting,
  buttonsBlockClassName,
}: FormLayoutProps) {

  let titleElement;

  if (typeof title === 'string') {
    titleElement = (<h3 className=" form-title">{title}</h3>);
  } else if (title) {
    titleElement = title;
  }

  const formContext = useFormContext();

  const isDisabled = formContext.isDisabled ? formContext.isDisabled() : false;

  return (
    <form
      data-testid={testID}
      className={`form ${className} ${isSubmitting ? styles.submitting : ''}`}
      autoComplete="nope"
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <input autoComplete="nope" name="hidden" type="text" style={{ display: 'none' }} />
      {titleElement}
      <ErrorsWrapper name="__form">
        <div className={`form-rows ${(!buttons) ? 'no-buttons' : ''}`}>
          <FormRows>
            {children}
          </FormRows>
        </div>
      </ErrorsWrapper>
      {buttons && !isDisabled && (
        <div className={`buttons ${buttonsBlockClassName}`}>
          {buttons}
        </div>
      )}
    </form>
  );
}

function DefaultLayout(props: FormLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnDefaultLayout {...props} />;
  } else {
    return <LegacyDefaultLayout {...props} />;
  }
}

export default DefaultLayout;
